export default __webpack_public_path__ + "static/media/TheGraphicSocial.113180c0.png";